import React, { useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown, ChevronUp } from "lucide-react";

const FinalQASection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: " Will Zylu really save me time in managing my salon?",
      answer: "Yes! Zylu automates bookings, reminders, and payments—so you and your staff spend less time on admin work and more time serving clients."
    },
    {
      question: "How can Zylu help me bring in more customers?",
      answer: "With features like online booking, customer reminders, and loyalty programs, Zylu helps you attract new clients and keep existing ones coming back."
    },
    {
      question: "Do I need to hire extra staff to manage Zylu?",
      answer: "Not at all. Zylu is simple and easy to use. In fact, it reduces the workload for you and your team instead of adding more."
    },
    {
      question: "Will my staff be able to use Zylu easily?",
      answer: "Yes, Zylu is designed for salons. Even if your staff isn’t very tech-savvy, they can learn it quickly with our training and support."
    },
    {
      question: "How soon can I see results after using Zylu?",
      answer: "Most salon owners notice improvements—like reduced no-shows, better customer management, and more repeat clients—within the first few weeks."
    },
    
   
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-8 md:mb-16"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 text-black">
            Frequently Asked Questions
          </h2>
          <div className="w-24 h-1 bg-red-500 mx-auto mb-8"></div>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Get answers to all your questions about Zylu salon management software.
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="mb-3 md:mb-4"
            >
              <div
                className="rounded-lg border border-gray-200 overflow-hidden cursor-pointer hover:border-red-500/50 transition-all duration-300"
                style={{ backgroundColor: '#f8f9fa' }}
              >
                <div
                  className="p-4 md:p-6 flex justify-between items-center hover:bg-gray-100/50 transition-colors duration-200"
                  onClick={() => toggleFAQ(index)}
                >
                  <h3 className="text-sm sm:text-base md:text-lg font-semibold text-black pr-2 md:pr-4">
                    {faq.question}
                  </h3>
                  <div className="flex-shrink-0">
                    {openIndex === index ? (
                      <ChevronUp className="h-4 w-4 md:h-5 md:w-5 text-red-500" />
                    ) : (
                      <ChevronDown className="h-4 w-4 md:h-5 md:w-5 text-gray-400" />
                    )}
                  </div>
                </div>
                
                <motion.div
                  initial={false}
                  animate={{
                    height: openIndex === index ? "auto" : 0,
                    opacity: openIndex === index ? 1 : 0
                  }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                  className="overflow-hidden"
                >
                  <div className="px-4 md:px-6 pb-4 md:pb-6">
                    <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </motion.div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FinalQASection;
